var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWingDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "18px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Wing") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wing",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.22539865,1.33439407 L9.50922812,2.56281389 L14.1216895,2.56281389 L14.4214858,13.8847708 L14.9177295,14.675 L14.2767082,14.675 L9.76778978,14.672772 L1.075,14.6703271 L1.075,13.9743044 L1.82647486,13.9743044 L1.82647486,1.59956111 L9.22539865,1.33439407 Z M7.8875557,8.85796401 L3.34692043,8.85796401 L3.34692043,13.9713989 L7.8875557,13.9713989 L7.8875557,8.85796401 Z M13.6997777,3.35306095 L9.59299335,3.35306095 L9.59299335,13.9713989 L13.6997777,13.9713989 L13.6997777,3.35306095 Z M12.4485978,7.94576179 L12.4485978,9.52747925 L10.8441732,9.52747925 L10.8441732,7.94576179 L12.4485978,7.94576179 Z M8.43945367,5.51038782 L5.68532405,5.51038782 L5.68532405,8.24332412 L8.43945367,8.24332412 L8.43945367,5.51038782 Z M5.58384919,5.51038782 L2.82971957,5.51038782 L2.82971957,8.24332412 L5.58384919,8.24332412 L5.58384919,5.51038782 Z M12.4485978,4.97013851 L12.4485978,6.55185597 L10.8441732,6.55185597 L10.8441732,4.97013851 L12.4485978,4.97013851 Z M5.58384919,2.68354571 L2.82971957,2.68354571 L2.82971957,5.41648201 L5.58384919,5.41648201 L5.58384919,2.68354571 Z M8.43945367,2.68354571 L5.68532405,2.68354571 L5.68532405,5.41648201 L8.43945367,5.41648201 L8.43945367,2.68354571 Z",
    id: "Combined-Shape",
    stroke: "#666666",
    strokeWidth: 0.65,
    fill: "#666666"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWingDark);
export default __webpack_public_path__ + "static/media/WingDark.de5fd64e.svg";
export { ForwardRef as ReactComponent };